module.exports = __webpack_public_path__ + "static/media/dhruvil-dhankani.b0c93fa0.png";